import ReadSmore from 'read-smore/dist/index.esm.js';
import { mount } from './dom-lifecycle';

mount('[data-read-smore]', function () {
    const options = {
        moreText: 'Rozwiń',
        lessText: 'Zwiń',
        wordsCount: 1,
    }
    ReadSmore([this], options).init();
    $(this).siblings('.read-smore__link-wrap').find('a').on('click', event => event.preventDefault());
});